const userRole = {
  GUEST: 'Guest',
  USER: 'User',
  ADMIN: 'Admin',
  AGENCY: 'Agency',
};

export default {
  ...userRole,
};